export enum ShareClassEnum {
  INVESTOR = 'INVESTOR',
  Institutional = 'Institutional',
  I = 'I',
  S = 'S',
  F = 'F',
  A = 'A',
  Adv = 'Adv',
  R = 'R',
  RETIREMENTA = 'RETIREMENT_A',
  RETIREMENTB = 'RETIREMENT_B',
  RETIREMENTF = 'RETIREMENT_F',
  BLENDA = 'BLEND_A',
  BLENDB = 'BLEND_B',
  BLENDC = 'BLEND_C',
  TARGETC = 'TARGET_C',
  STABLEA = 'STABLE_A',
  STABLEB = 'STABLE_B',
  STABLEK = 'STABLE_K',
}
